import type { User, Auth, Finance } from '../types';

/**
 * 将用户信息转换为User类型
 * @param user 用户信息
 * @returns 
 */
export const toUser = (user: any): User => ({
  secretKeyCode: user.secretKeyCode ?? 0,
  userName: user.userName ?? '',
  phone: user.phone ?? '',
  nickName: user.nickName ?? '',
  avatar: (user.avatar == null || user.avatar == '') ? 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png' : user.avatar,
  roles: user.roles ?? 0,
  isLoginPassword: user.isLoginPassword ?? false,
  isTradePassword: user.isTradePassword ?? '1',
  authStatus: user.authStatus ?? '',
  contractStatus: user.contractStatus ?? '',
  accessTime: user.accessTime ?? '',
  createTime: user.createTime ?? ''
});

/**
 * 将认证信息转换为Auth类型
 */
export const toAuth = (data: any): Auth => ({
  userId: data.userId ?? 0,
  secretKeyCode: data.secretKeyCode ?? 0,
  secretKeyStatus: data.secretKeyStatus ?? '',
  identityName: data.identityName ?? '',
  companyName: data.companyName ?? '',
  identityNumber: data.identityNumber ?? '',
  frontPhoto: data.frontPhoto ?? '',
  backPhoto: data.backPhoto ?? '',
  isContract: data.isContract ?? '',
  // 0:审核中 1:审核成功 2:审核拒绝 default:未提交认证
  status: data.status ?? 'default',
  // 认证方式: 0:个人认证 1:企业认证 default:未认证
  authType: data.authType ?? '',
  reason: data.reason ?? '',
  legalRepresentative: data.legalRepresentative ?? '',
  uscc: data.uscc ?? '',
  registerAddress: data.registerAddress ?? '',
  officeAddress: data.officeAddress ?? '',
  businessLicense: data.businessLicense ?? '',
  issueDate: data.issueDate ?? '',
  expiryDate: data.expiryDate ?? '',
  contactsName: data.contactsName ?? '',
  contactsPhone: data.contactsPhone ?? '',
  createTime: data.createTime ?? ''
})

/**
 * 将财务信息转换为Auth类型
 */
export const toFinance = (data: any): Finance => ({
  useMoney: data.useMoney ?? 0,
  supMoney: data.supMoney ?? 0,
  withdrawal: data.withdrawal ?? 0,
  deposit: data.deposit ?? 0,
  creditLine: data.creditLine ?? 0,
  isPassword: data.isPassword ?? false
})

/**
 * 将用户封禁信息转换为UserBanned类型
 */
export const toBanned = (data: any): any => ({
  secretKeyCode: data.userId ?? '',
  purchaseSupply: data.secretKeyCode ?? -1,
  status: data.status ?? '0',
  reason: data.reason ?? '',
  bannedStartTime: data.bannedStartTime ?? '',
  bannedEndTime: data.bannedEndTime ?? '',
  unBannedTime: data.unBannedTime ?? '',
})